var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page checkout" },
    [
      _c(
        "h2",
        {
          staticClass: "text-center mt-7",
          staticStyle: { "margin-bottom": "2px" },
        },
        [_vm._v("Bestellung & Bezahlung ")]
      ),
      _c("div", { staticClass: "text-center" }, [
        _c("h4", { staticClass: "mb-6" }, [
          _vm._v("Gesamtsumme: "),
          _c("span", { staticClass: "textFont" }, [
            _vm._v(_vm._s(_vm._f("priceTotal")(_vm.total))),
          ]),
        ]),
      ]),
      _c(
        "v-container",
        { staticClass: "ccontainer", attrs: { "grid-list-md": "" } },
        [
          _c(
            "div",
            { staticClass: "kioskCheckoutContainer" },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "vvd orderform",
                  attrs: { vertical: "", id: "stepper" },
                  model: {
                    value: _vm.currentStep,
                    callback: function ($$v) {
                      _vm.currentStep = $$v
                    },
                    expression: "currentStep",
                  },
                },
                [
                  _c(
                    "v-stepper-step",
                    {
                      attrs: { complete: _vm.currentStep > 1, step: "1" },
                      nativeOn: {
                        "&click": function ($event) {
                          _vm.currentStep = 1
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "nice-title titleFont" }, [
                        _vm._v("Deine Bestelldaten"),
                      ]),
                    ]
                  ),
                  _c("v-stepper-content", { attrs: { step: "1" } }, [
                    _vm.usecase.length > 0
                      ? _c("div", { attrs: { id: "checkData" } }, [
                          _c(
                            "div",
                            { staticClass: "bestelldaten pt-1" },
                            [
                              _c(
                                "v-form",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showForm,
                                      expression: "showForm",
                                    },
                                  ],
                                  ref: "orderDataForm",
                                  attrs: { "lazy-validation": "" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                  model: {
                                    value: _vm.valid,
                                    callback: function ($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "prelative" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          value: _vm.name,
                                          label: "Vor- und Nachname*",
                                          rules: _vm.nameRules,
                                          placeholder: "Vorname Nachname",
                                          illed: "",
                                          "hide-details": "",
                                          required: "",
                                        },
                                        on: {
                                          input: _vm.updateName,
                                          focus: _vm.hideToolbar,
                                          blur: _vm.unhideToolbar,
                                        },
                                      }),
                                      _vm.name
                                        ? _c(
                                            "div",
                                            { staticClass: "absClear" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "myBlack",
                                                  on: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      _vm.name = ""
                                                    },
                                                  },
                                                },
                                                [_vm._v("mdi-close ")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "prelative" },
                                    [
                                      _c("v-text-field", {
                                        ref: "email",
                                        attrs: {
                                          outlined: "",
                                          value: _vm.email,
                                          rules: _vm.emailRules,
                                          label:
                                            "E-Mail (vorgeschrieben für Online-Zahlung)",
                                          illed: "",
                                          "hide-details": "",
                                          required: "",
                                        },
                                        on: {
                                          input: _vm.updateEmail,
                                          focus: _vm.hideToolbar,
                                          blur: _vm.unhideToolbar,
                                        },
                                      }),
                                      _vm.email
                                        ? _c(
                                            "div",
                                            { staticClass: "absClear" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "myBlack",
                                                  on: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      _vm.email = ""
                                                    },
                                                  },
                                                },
                                                [_vm._v("mdi-close ")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.$store.state.enableOrderNote
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "prelative" },
                                          [
                                            _c("v-text-field", {
                                              ref: "phone",
                                              attrs: {
                                                outlined: "",
                                                value: _vm.phone,
                                                rules: _vm.phoneRules,
                                                label: "Mobilnummer",
                                                placeholder: "",
                                                illed: "",
                                              },
                                              on: {
                                                keydown: function ($event) {
                                                  return _vm.phoneKeydown(
                                                    $event
                                                  )
                                                },
                                                input: _vm.updatePhone,
                                              },
                                            }),
                                            _vm.phone
                                              ? _c(
                                                  "div",
                                                  { staticClass: "absClear" },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "myBlack",
                                                        on: {
                                                          "&click": function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            _vm.phone = ""
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("mdi-close ")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c("v-text-field", {
                                          ref: "note",
                                          staticClass: "nolabel",
                                          attrs: {
                                            outlined: "",
                                            "hide-details": "",
                                            label: "Notiz",
                                            clearable: "",
                                            illed: "",
                                          },
                                          on: {
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              return _vm.finishStep1.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.note,
                                            callback: function ($$v) {
                                              _vm.note = $$v
                                            },
                                            expression: "note",
                                          },
                                        }),
                                      ]
                                    : [
                                        _c("v-text-field", {
                                          ref: "phone",
                                          attrs: {
                                            outlined: "",
                                            rules: _vm.phoneRules,
                                            label: "Mobilnummer",
                                            placeholder: "Für evtl. Rückfragen",
                                            illed: "",
                                          },
                                          on: {
                                            keydown: function ($event) {
                                              return _vm.phoneKeydown($event)
                                            },
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              return _vm.finishStep1.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.phone,
                                            callback: function ($$v) {
                                              _vm.phone = $$v
                                            },
                                            expression: "phone",
                                          },
                                        }),
                                        _vm.phone
                                          ? _c(
                                              "div",
                                              { staticClass: "absClear" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "myBlack",
                                                    on: {
                                                      "&click": function (
                                                        $event
                                                      ) {
                                                        $event.stopPropagation()
                                                        _vm.phone = ""
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("mdi-close ")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _vm.step1Error && _vm.initialTry
                                ? _c(
                                    "div",
                                    { staticClass: "error--text mt-2 mb-4" },
                                    [_vm._v(_vm._s(_vm.step1Error))]
                                  )
                                : _vm._e(),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "primepulsing btn-df weiter",
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.finishStep1.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Weiter ")]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.currentStep > 2, step: "2" } },
                    [
                      _c("div", { staticClass: "nice-title titleFont" }, [
                        _vm._v("Bezahlung"),
                        _vm.psp === "bar"
                          ? _c("span", [_vm._v(": Bar")])
                          : _vm._e(),
                        _vm.psp === ""
                          ? _c("span", [_vm._v(": Online")])
                          : _vm._e(),
                        _vm.psp === "beiAbholung"
                          ? _c("span", [_vm._v(": Bei Abholung")])
                          : _vm._e(),
                        _vm.psp === "vorkasse"
                          ? _c("span", [_vm._v(": Vorkasse")])
                          : _vm._e(),
                        _vm.psp === "credit"
                          ? _c("span", [
                              _vm._v(": Girocard/Debitkarte oder Kreditkarte"),
                            ])
                          : _vm._e(),
                        _vm.psp === "wallet"
                          ? _c("span", [_vm._v(": Apple/Google Pay")])
                          : _vm._e(),
                        _vm.psp === "googlewallet"
                          ? _c("span", [_vm._v(": Google Pay")])
                          : _vm._e(),
                        _vm.psp === "applewallet"
                          ? _c("span", [_vm._v(": Apple Pay")])
                          : _vm._e(),
                        _vm.psp === "customerCard"
                          ? _c("span", [_vm._v(": Kundenkarte")])
                          : _vm._e(),
                        _vm.psp === "paypal"
                          ? _c("span", [_vm._v(": PayPal/Lastschrift")])
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _c(
                    "v-stepper-content",
                    { attrs: { id: "paymentRadios", step: "2" } },
                    [
                      !_vm.showSubmitButton
                        ? _c("h4", [_vm._v("Wähle eine Zahlungsmethode:")])
                        : _vm._e(),
                      _vm.showSubmitButton
                        ? _c(
                            "v-radio-group",
                            {
                              staticClass: "vvd-radio",
                              attrs: { light: "", "hide-details": "" },
                              nativeOn: {
                                "&click": function ($event) {
                                  return _vm.clickRadio.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.psp,
                                callback: function ($$v) {
                                  _vm.psp = $$v
                                },
                                expression: "psp",
                              },
                            },
                            [
                              _vm.showGoodpayCc
                                ? _c("v-radio", {
                                    key: "credit",
                                    staticClass: "mb-4",
                                    attrs: {
                                      label:
                                        "Girocard/Debitkarte oder Kreditkarte",
                                      value: "credit",
                                      "hide-details": "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showPaypal
                                ? _c("v-radio", {
                                    key: "paypal",
                                    staticClass: "mb-4",
                                    attrs: {
                                      label: "PayPal/Lastschrift",
                                      value: "paypal",
                                      "hide-details": "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showGoodpayGoogleWallet
                                ? _c("v-radio", {
                                    key: "googlewallet",
                                    staticClass: "mb-4",
                                    attrs: {
                                      label: "Google Pay",
                                      value: "googlewallet",
                                      "hide-details": "",
                                    },
                                  })
                                : _vm._e(),
                              _vm.showGoodpayAppleWallet
                                ? _c("v-radio", {
                                    key: "applewallet",
                                    staticClass: "mb-4",
                                    attrs: {
                                      label: "Apple Pay",
                                      value: "applewallet",
                                      "hide-details": "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.psp === "credit",
                              expression: "psp ==='credit'",
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.paymentMethods.length > 0,
                                  expression: "paymentMethods.length > 0",
                                },
                              ],
                            },
                            _vm._l(_vm.paymentMethods, function (pMethod) {
                              return _c(
                                "div",
                                {
                                  key: pMethod.aliasId,
                                  staticClass: "paymentMethodsBox pointer",
                                  on: {
                                    "&click": function ($event) {
                                      return _vm.selectMethod(pMethod)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "table",
                                    { staticClass: "paymentRowsTable" },
                                    [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticStyle: { width: "40px" } },
                                          [
                                            _vm.selectedAliasId ===
                                            pMethod.aliasId
                                              ? _c(
                                                  "v-icon",
                                                  { staticClass: "myBlack" },
                                                  [
                                                    _vm._v(
                                                      " mdi-check-circle-outline "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "v-icon",
                                                  { staticClass: "myBlack" },
                                                  [_vm._v("mdi-radiobox-blank")]
                                                ),
                                          ],
                                          1
                                        ),
                                        _c("td", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(pMethod.label) +
                                                " " +
                                                _vm._s(pMethod.xxxNumber)
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "expLabel" },
                                            [_vm._v(_vm._s(pMethod.exp))]
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "btn-mini",
                                                nativeOn: {
                                                  "&click": function ($event) {
                                                    return _vm.gotoPms(true)
                                                  },
                                                },
                                              },
                                              [_vm._v("Andere Karte ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm.enableGoodpay && _vm.paymentMethods.length === 0
                            ? _c(
                                "div",
                                { staticClass: "pb-5" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-df",
                                      nativeOn: {
                                        "&click": function ($event) {
                                          return _vm.gotoPms.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Karte hinzufügen ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "acceptAgbs align-center mt-4" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "option pointer",
                                  class: { selected: _vm.accceptedAgbs },
                                  on: {
                                    "&click": function ($event) {
                                      _vm.accceptedAgbs = !_vm.accceptedAgbs
                                    },
                                  },
                                },
                                [
                                  _vm.accceptedAgbs
                                    ? _c("v-icon", [
                                        _vm._v(" mdi-check-box-outline "),
                                      ])
                                    : _c("v-icon", [
                                        _vm._v("mdi-checkbox-blank-outline"),
                                      ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "fasterGrow checkbox-label" },
                                [_c("AcceptAgbsText")],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showGpSubmit,
                                  expression: "showGpSubmit",
                                },
                              ],
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !_vm.$store.getters.showLoading,
                                          expression:
                                            "!$store.getters.showLoading",
                                        },
                                      ],
                                      staticClass:
                                        "mt-6 mb-2 orderBtn wallet-width text-none rounded100",
                                      attrs: { color: "green", dark: "" },
                                      nativeOn: {
                                        "&click": function ($event) {
                                          return _vm.submitCc.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Zahlungspflichtig bestellen ")]
                                  ),
                                ],
                                1
                              ),
                              _c("div", [_c("orderconsent")], 1),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.psp.includes("wallet"),
                              expression: "psp.includes('wallet')",
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.psp === "googlewallet",
                                  expression: "psp === 'googlewallet'",
                                },
                              ],
                              staticClass: "pb-5",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "acceptAgbs align-center mt-2 mb-4",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "option pointer",
                                      class: { selected: _vm.accceptedAgbs },
                                      on: {
                                        "&click": function ($event) {
                                          _vm.accceptedAgbs = !_vm.accceptedAgbs
                                        },
                                      },
                                    },
                                    [
                                      _vm.accceptedAgbs
                                        ? _c("v-icon", [
                                            _vm._v(" mdi-check-box-outline "),
                                          ])
                                        : _c("v-icon", [
                                            _vm._v(
                                              "mdi-checkbox-blank-outline"
                                            ),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "fasterGrow checkbox-label",
                                    },
                                    [_c("AcceptAgbsText")],
                                    1
                                  ),
                                ]
                              ),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.goodpayHasPaymentRequest &&
                                      _vm.email &&
                                      !_vm.$store.getters.showLoading,
                                    expression:
                                      "goodpayHasPaymentRequest && email && !$store.getters.showLoading",
                                  },
                                ],
                                ref: "googlePay",
                                staticClass: "walletButton",
                                on: {
                                  click: function ($event) {
                                    return _vm.googlePaymentClicked(
                                      "google-pay"
                                    )
                                  },
                                },
                              }),
                              _c("br"),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.psp === "applewallet",
                                  expression: "psp === 'applewallet'",
                                },
                              ],
                              staticClass: "pb-5",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "acceptAgbs align-center mt-2 mb-4",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "option pointer",
                                      class: { selected: _vm.accceptedAgbs },
                                      on: {
                                        "&click": function ($event) {
                                          _vm.accceptedAgbs = !_vm.accceptedAgbs
                                        },
                                      },
                                    },
                                    [
                                      _vm.accceptedAgbs
                                        ? _c("v-icon", [
                                            _vm._v(" mdi-check-box-outline "),
                                          ])
                                        : _c("v-icon", [
                                            _vm._v(
                                              "mdi-checkbox-blank-outline"
                                            ),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "fasterGrow checkbox-label",
                                    },
                                    [_c("AcceptAgbsText")],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.canMakePayments &&
                                        _vm.email &&
                                        !_vm.$store.getters.showLoading,
                                      expression:
                                        "canMakePayments && email && !$store.getters.showLoading",
                                    },
                                  ],
                                  staticClass: "walletButton",
                                },
                                [
                                  _c("apple-pay-button", {
                                    staticClass: "pointer",
                                    attrs: {
                                      buttonstyle: "black",
                                      type: "plain",
                                      locale: "de-DE",
                                    },
                                    on: {
                                      click: _vm.onApplePaymentButtonClicked,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("br"),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.psp.includes("wallet"),
                                  expression: "psp.includes('wallet')",
                                },
                              ],
                            },
                            [_c("orderconsent")],
                            1
                          ),
                          _vm.psp === "credit" && _vm.selectedAliasId.length > 0
                            ? _c("div", [_c("orderconsent")], 1)
                            : _vm._e(),
                        ]
                      ),
                      _vm.psp === "bar" || _vm.psp === "customerCard"
                        ? _c("div", [
                            _vm.showCustomerCard
                              ? _c("div", [
                                  this.total <=
                                  _vm.$store.getters.cards
                                    .find(
                                      (c) =>
                                        c.rfid ===
                                        _vm.$store.getters.bbnUser.primaryCardId
                                    )
                                    .accounts.find(
                                      (a) => a.accountType === "CRED"
                                    ).balance
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "mt-2 mb-2" },
                                            [
                                              _vm._v(
                                                "Das Guthaben von " +
                                                  _vm._s(
                                                    _vm.$store.getters.cards
                                                      .find(
                                                        (c) =>
                                                          c.rfid ===
                                                          _vm.$store.getters
                                                            .bbnUser
                                                            .primaryCardId
                                                      )
                                                      .accounts.find(
                                                        (a) =>
                                                          a.accountType ===
                                                          "CRED"
                                                      ).balance
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$store.getters.cards
                                                      .find(
                                                        (c) =>
                                                          c.rfid ===
                                                          _vm.$store.getters
                                                            .bbnUser
                                                            .primaryCardId
                                                      )
                                                      .accounts.find(
                                                        (a) =>
                                                          a.accountType ===
                                                          "CRED"
                                                      ).symbol
                                                  ) +
                                                  " ist ausreichend "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.showSubmitButton &&
                                                        !_vm.$store.getters
                                                          .showLoading,
                                                      expression:
                                                        "showSubmitButton && !$store.getters.showLoading",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "mt-3 mb-5 orderBtn wallet-width text-none rounded100",
                                                  attrs: {
                                                    color: "green",
                                                    dark: "",
                                                  },
                                                  nativeOn: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      return _vm.doOrder.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " Zahlungspflichtig bestellen "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("orderconsent"),
                                        ],
                                        1
                                      )
                                    : _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "mt-2 mb-2" },
                                          [
                                            _vm._v(
                                              "Das Guthaben von " +
                                                _vm._s(
                                                  _vm.$store.getters.cards
                                                    .find(
                                                      (c) =>
                                                        c.rfid ===
                                                        _vm.$store.getters
                                                          .bbnUser.primaryCardId
                                                    )
                                                    .accounts.find(
                                                      (a) =>
                                                        a.accountType === "CRED"
                                                    ).balance
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$store.getters.cards
                                                    .find(
                                                      (c) =>
                                                        c.rfid ===
                                                        _vm.$store.getters
                                                          .bbnUser.primaryCardId
                                                    )
                                                    .accounts.find(
                                                      (a) =>
                                                        a.accountType === "CRED"
                                                    ).symbol
                                                ) +
                                                " ist "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "bold" },
                                              [_vm._v("nicht ausreichend")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "btn-mini mt-2 mb-2",
                                                on: {
                                                  "&click": function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.chooseCustomercard.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Andere Karte wählen ")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "btn-mini mt-2 mb-2",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.psp = ""
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "Andere Zahlungsmethode wählen"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                ])
                              : _c("div", [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-mini mt-2 mb-2",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$ebus.$emit("goto", {
                                                name: "Karten",
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("Hauptkarte auswählen ")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-mini mt-2 mb-2",
                                          on: {
                                            click: function ($event) {
                                              _vm.psp = ""
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Andere Zahlungsmethode wählen"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.psp === "paypal",
                              expression: "psp === 'paypal'",
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "acceptAgbs align-center mt-3" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "option pointer",
                                  class: { selected: _vm.accceptedAgbs },
                                  on: {
                                    "&click": function ($event) {
                                      _vm.accceptedAgbs = !_vm.accceptedAgbs
                                    },
                                  },
                                },
                                [
                                  _vm.accceptedAgbs
                                    ? _c("v-icon", [
                                        _vm._v(" mdi-check-box-outline "),
                                      ])
                                    : _c("v-icon", [
                                        _vm._v("mdi-checkbox-blank-outline"),
                                      ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "fasterGrow checkbox-label" },
                                [_c("AcceptAgbsText")],
                                1
                              ),
                            ]
                          ),
                          _c("div", {
                            staticClass: "walletButtonWidth pt-3",
                            attrs: { id: "paypal-button-container" },
                          }),
                          _c("table", [
                            _c("tr", [_c("td", [_c("orderconsent")], 1)]),
                          ]),
                        ]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "bback",
                          nativeOn: {
                            "&click": function ($event) {
                              _vm.currentStep = 1
                            },
                          },
                        },
                        [_vm._v(" Zurück ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("ssl-seal"),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "v-btn",
            {
              staticClass: "text-none btn-mini",
              staticStyle: { "margin-top": "25px" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v(" Bestellung abbrechen ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "spacer-25" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }